var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    [
      _c(
        "gg-card",
        [
          _c("gg-card-header", [_vm._v(" DNS Editor ")]),
          _c(
            "gg-card-text",
            [
              _c(
                "v-container",
                {
                  staticClass: "grid-size-xs pa-0",
                  attrs: {
                    fluid: ""
                  }
                },
                [
                  _c(
                    "v-row",
                    [
                      _c(
                        "v-col",
                        {
                          staticClass: "d-block",
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "gg-btn",
                            {
                              staticClass: "mr-2",
                              attrs: {
                                color: "primary",
                                tile: "",
                                disabled: _vm.loading
                              },
                              on: {
                                click: function click($event) {
                                  return _vm.openActionModal("add")
                                }
                              }
                            },
                            [_vm._v(" Add new record ")]
                          ),
                          _c(
                            "gg-btn",
                            {
                              staticClass: "mx-2",
                              attrs: {
                                disabled: _vm.loading,
                                tile: ""
                              },
                              on: {
                                click: _vm.setRecordsToModel
                              }
                            },
                            [_vm._v(" Refresh records ")]
                          )
                        ],
                        1
                      ),
                      _vm.isAddModeActive
                        ? _c("records-edit", {
                            attrs: {
                              "is-active": _vm.isAddModeActive,
                              "edit-mode": "add",
                              title: "Add record",
                              hint: _vm.dnsHint,
                              allowed_types: _vm.allowed_types,
                              record: _vm.edited_record,
                              loading: _vm.loading,
                              "submit-function": _vm.addNewRecord
                            },
                            on: {
                              changed: _vm.listenRecord,
                              close: _vm.closeDialog
                            }
                          })
                        : _vm._e(),
                      _vm.isEditModeActive
                        ? _c("records-edit", {
                            attrs: {
                              "is-active": _vm.isEditModeActive,
                              "edit-mode": "edit",
                              title: "Edit record",
                              hint: _vm.dnsHint,
                              "submit-function": _vm.editExistingRecord,
                              allowed_types: _vm.allowed_types,
                              record: _vm.edited_record,
                              loading: _vm.loading
                            },
                            on: {
                              changed: _vm.listenRecord,
                              close: _vm.closeDialog
                            }
                          })
                        : _vm._e(),
                      _vm.isDeleteModeActive
                        ? _c("records-edit", {
                            attrs: {
                              "is-active": _vm.isDeleteModeActive,
                              "edit-mode": "delete",
                              title: "Are you sure want to delete this record?",
                              hint: _vm.dnsHint,
                              "submit-function": _vm.deleteRecord,
                              allowed_types: _vm.allowed_types,
                              record: _vm.edited_record,
                              loading: _vm.loading
                            },
                            on: {
                              changed: _vm.listenRecord,
                              close: _vm.closeDialog
                            }
                          })
                        : _vm._e(),
                      _c(
                        "v-col",
                        {
                          attrs: {
                            cols: "12"
                          }
                        },
                        [
                          _c(
                            "gg-loading",
                            {
                              attrs: {
                                loading: _vm.loading,
                                type: "table"
                              }
                            },
                            [
                              _c("v-data-table", {
                                attrs: {
                                  headers: _vm.headers,
                                  items: _vm.records,
                                  "footer-props": {
                                    itemsPerPageOptions: _vm.pagination
                                  }
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "item.actions",
                                    fn: function fn(_ref) {
                                      var item = _ref.item,
                                        index = _ref.index
                                      return [
                                        _c(
                                          "gg-btn",
                                          {
                                            staticClass: "mr-1",
                                            attrs: {
                                              tile: "",
                                              color: "primary",
                                              disabled: _vm.loading
                                            },
                                            on: {
                                              click: function click($event) {
                                                return _vm.openActionModal(
                                                  "edit",
                                                  item,
                                                  index
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(" Edit ")]
                                        ),
                                        _c(
                                          "gg-btn",
                                          {
                                            attrs: {
                                              tile: "",
                                              color: "gray",
                                              disabled: _vm.loading
                                            },
                                            on: {
                                              click: function click($event) {
                                                return _vm.openActionModal(
                                                  "delete",
                                                  item,
                                                  index
                                                )
                                              }
                                            }
                                          },
                                          [_vm._v(" Delete ")]
                                        )
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }